import { Avatar, Menu } from "antd";
import React from "react";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoPersonAddSharp, IoSettingsSharp } from "react-icons/io5";
import { MdOutlineLogout, MdPeopleAlt } from "react-icons/md";
import { PiChats } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { roles } from "../../config/roles";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import "./sideMenu.css";
import { checkRouteName } from "../../utills";
import Person from "../../assets/images/staticImages/person.png";
import TextComponent from "../textComponent/TextComponent";
import styles from "./sideMenu.css";
import { IoPersonCircleOutline } from "react-icons/io5";
import { isLogin } from "../../Store/Actions/AuthAction";

// SVG Imports
import { ReactComponent as HomeIcon } from "../../assets/images/sidebarIcons/homeIcon.svg";
import { ReactComponent as Equipment } from "../../assets/images/sidebarIcons/Equipment.svg";
import { ReactComponent as Group } from "../../assets/images/sidebarIcons/Group.svg";
import { ReactComponent as CCSIcon } from "../../assets/images/sidebarIcons/CCSIcon.svg";
import { ReactComponent as BMIcon } from "../../assets/images/sidebarIcons/BMIcon.svg";
import { ReactComponent as Warehouse } from "../../assets/images/sidebarIcons/Warehouse.svg";
import { ReactComponent as CM } from "../../assets/images/sidebarIcons/componentsManagementIcon.svg";
import { ReactComponent as MM } from "../../assets/images/sidebarIcons/materialManagementIcon.svg";
import { ReactComponent as RM } from "../../assets/images/sidebarIcons/Relationship Mgmt.svg";
import { ReactComponent as UM } from "../../assets/images/sidebarIcons/userMg.svg";
import { ReactComponent as WL } from "../../assets/images/sidebarIcons/wasteLogIcon.svg";
import { ReactComponent as Ing } from "../../assets/images/sidebarIcons/Ing.svg";
import { ReactComponent as BSIcon } from "../../assets/images/sidebarIcons/BAkerySetupIcon.svg";
import { ReactComponent as OMIcon } from "../../assets/images/sidebarIcons/OrderMGMTIcon.svg";
import { ReactComponent as USRIcon } from "../../assets/images/sidebarIcons/UserMgmt.svg";
import { ReactComponent as STFIcon } from "../../assets/images/sidebarIcons/StafMgmt.svg";
import { ReactComponent as TRAIcon } from "../../assets/images/sidebarIcons/Training.svg";
import { ReactComponent as HLPIcon } from "../../assets/images/sidebarIcons/HelpSupport.svg";
import { ReactComponent as PMIcon } from "../../assets/images/sidebarIcons/ProductionManagementIcon.svg";
import { ReactComponent as ComplianceIcon } from "../../assets/images/sidebarIcons/ComplianceIcon.svg";
import { ReactComponent as AllergenIcon } from "../../assets/images/sidebarIcons/AllergenIcon.svg";
import { ReactComponent as BillingIcon } from "../../assets/images/sidebarIcons/AllergenIcon.svg";
import { ReactComponent as LocationMGMT } from "../../assets/images/sidebarIcons/LocationMGMT.svg";
import { ReactComponent as PRIcon } from "../../assets/images/sidebarIcons/privacy.svg";
import { ReactComponent as TERIcon } from "../../assets/images/sidebarIcons/terms.svg";
import { ReactComponent as CONIcon } from "../../assets/images/sidebarIcons/contacts.svg";
import { ReactComponent as FAQIcon } from "../../assets/images/sidebarIcons/faqs.svg";
import { ReactComponent as ProcessIcon } from "../../assets/images/sidebarIcons/ProcessIcon.svg";
import { ReactComponent as RecipeProduction } from "../../assets/images/sidebarIcons/recipeProduction.svg";
import { ReactComponent as SettingsIcon } from "../../assets/images/sidebarIcons/settingsIcon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/images/sidebarIcons/LogoutIcon.svg";
import { ReactComponent as ReciepeIcon } from "../../assets/images/sidebarIcons/reciepeIcon.svg";
import { ReactComponent as SupEquipmentIcon } from "../../assets/images/sidebarIcons/supEquipIcon.svg";
import { ReactComponent as SuptrainingIcon } from "../../assets/images/sidebarIcons/suptrainingIcon.svg";
import { ReactComponent as TrainingLibrary } from "../../assets/images/sidebarIcons/trainingLiabrary 1.svg";
import { ReactComponent as VN } from "../../assets/images/sidebarIcons/vendorManagement.svg";
import { ReactComponent as PS } from "../../assets/images/sidebarIcons/ProductionSched.svg";
import { ReactComponent as Reports } from "../../assets/images/sidebarIcons/Reports.svg";
import { ReactComponent as EmergencyPhone } from "../../assets/images/sidebarIcons/emergency-phone.svg";
import { useTranslation } from "react-i18next";
import { TbReportSearch } from "react-icons/tb";

const menuStyle = {
  borderRadius: 0,
  width: "100%",
  margin: 0,
  paddingLeft: 0,
  borderTopLeftRadius: "0px",
  borderBottomLeftRadius: "0px",
  fontFamily: "var(--font-family)",
  backgroundColor: "var(--sideMenu-item-color)",
};

const StaffMemberMenu = ({ navigation, dispatch, t, width }) => {
  const logout = () => {
    dispatch(isLogin(false));
    localStorage.clear();
  };
  return [
    {
      style: menuStyle,
      key: "StaffDashboard",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HomeIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Home")}</h4>,
      onClick: () => {
        navigation("/StaffDashboard");
      },
    },
    {
      style: menuStyle,
      key: "StaffProductionSchedule",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <PS width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Production Schedule </h4>,
      onClick: () => {
        navigation("/StaffProductionSchedule");
      },
    },
    {
      style: menuStyle,
      key: "StaffRecipeProduction",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <RecipeProduction width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable"> Recipe Production </h4>,
      onClick: () => {
        navigation("/StaffRecipeProduction");
      },
    },
    {
      style: menuStyle,
      key: "StaffEquipment",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SupEquipmentIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable"> Equipment </h4>,
      onClick: () => {
        navigation("/StaffEquipment");
      },
    },

    {
      style: menuStyle,
      key: "Warehouse ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <Warehouse width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Warehouse </h4>,
      children: [
        {
          key: "StaffIngredients",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <Ing width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Ingredients
            </span>
          ),
          onClick: () => navigation("/StaffWarehouse/StaffIngredients"),
        },
        {
          key: "StaffMaterial",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <MM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Material
            </span>
          ),
          onClick: () => navigation("/StaffWarehouse/StaffMaterial"),
        },
        {
          key: "StaffWasteLog",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <WL width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              WasteLog
            </span>
          ),
          onClick: () => navigation("/StaffWarehouse/StaffWasteLog"),
        },
        {
          key: "StaffComponentMGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Components
            </span>
          ),
          onClick: () => navigation("/Warehouse/StaffComponentMGMT"),
        },
        //
      ],
      // onClick: () => navigation("/Settings"),
    },

    {
      style: menuStyle,
      key: "StaffTraining ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SuptrainingIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Training</h4>,
      children: [
        {
          key: "Training Library",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TrainingLibrary width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Training Library
            </span>
          ),
          onClick: () => navigation("/StaffTraining"),
        },
        {
          key: "Recipe",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <ReciepeIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Recipe
            </span>
          ),
          onClick: () => navigation("/Staff/Recipe"),
        },
      ],
    },

    {
      style: menuStyle,
      key: "Support & Help",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HLPIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Support & Help</h4>,
      children: [
        {
          key: "Privacy & Policy",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <PRIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Privacy & Policy
            </span>
          ),
          onClick: () => navigation("/PrivacyPolicy"),
        },
        {
          key: "Terms & Condition",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TERIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Terms & Condition
            </span>
          ),
          onClick: () => navigation("/TermsConditions"),
        },
        {
          key: "Contact Us",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CONIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Contact Us
            </span>
          ),
          onClick: () => navigation("/ContactUs/"),
        },
        {
          key: "FAQ’s",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <FAQIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              FAQ’s
            </span>
          ),
          onClick: () => navigation("/Faqs"),
        },
        {
          key: "Emergency Contacts",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <EmergencyPhone width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Emergency Contacts
            </span>
          ),
          onClick: () => navigation("/EmergencyContacts"),
        },
      ],
    },
    {
      style: menuStyle,
      key: "Settings",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SettingsIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Settings</h4>,
      onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Logout",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <LogoutIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Logout</h4>,
      onClick: () => logout(),
    },
  ];
};
const adminMenu = ({ navigation, dispatch, t, width }) => {
  const logout = () => {
    dispatch(isLogin(false));
    localStorage.clear();
  };

  return [
    {
      style: menuStyle,
      key: "AdminDashboard",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HomeIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Home")}</h4>,
      onClick: () => {
        navigation("/AdminDashboard");
      },
    },
    {
      style: menuStyle,
      key: "CentralCommandScreen",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <CCSIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Central Command Screen </h4>,
      onClick: () => navigation("/CentralCommandScreen"),
    },
    {
      style: menuStyle,
      key: "BusinessManagement ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <BMIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Business MGMT</h4>,
      children: [
        {
          key: "BakerySetup",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <BSIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Bakery Setup
            </span>
          ),
          onClick: () => navigation("/AdminBuisnessManagement/BakerySetup"),
        },
        {
          key: "LocationManagement",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <LocationMGMT width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Location MGMT
            </span>
          ),
          onClick: () =>
            navigation("/AdminBuisnessManagement/LocationManagement"),
        },
        {
          key: "BillingSubscription",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <BillingIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Billing & Subscription
            </span>
          ),
          onClick: () =>
            navigation("/AdminBuisnessManagement/BillingSubscription"),
        },
        {
          key: "EventLog",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <BillingIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Event Log
            </span>
          ),
          onClick: () => navigation("/AdminBuisnessManagement/EventLog"),
        },
        {
          key: "AdminAnalyticsReports",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <BillingIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Analytics & Reports
            </span>
          ),
          onClick: () =>
            navigation("/AdminBuisnessManagement/AnalyticsReports"),
        },
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Warehouse ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <Warehouse width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Warehouse </h4>,
      children: [
        {
          key: "IngredientsMGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <Ing width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Ingredients MGMT
            </span>
          ),
          onClick: () => navigation("/Warehouse/IngredientsMgmt"),
        },
        {
          key: "WasteLog",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <WL width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Waste Log
            </span>
          ),
          onClick: () => navigation("/Warehouse/WasteLog"),
        },
        {
          key: "MaterialMGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <MM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Material MGMT
            </span>
          ),
          onClick: () => navigation("/Warehouse/MaterialMGMT"),
        },
        {
          key: "ComponentMGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Component MGMT
            </span>
          ),
          onClick: () => navigation("/Warehouse/ComponentMGMT"),
        },
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Production Management",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <PMIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Production MGMT</h4>,

      children: [
        {
          key: "Order Management",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <OMIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Order Management
            </span>
          ),
          onClick: () => navigation("/AdminOrderManagement"),
        },
        {
          key: "Process MGMT.",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <ProcessIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Process MGMT.
            </span>
          ),
          onClick: () => navigation("/ProductionManagement/ProcessManagement"),
        },
        {
          key: "Compliance MGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <ComplianceIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Compliance Management
            </span>
          ),
          onClick: () =>
            navigation("/AdminProductManagement/ComplianceManagement"),
        },

        {
          key: "Allergan Management",

          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <AllergenIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Allergan Management
            </span>
          ),
          onClick: () =>
            navigation("/AdminProductManagement/AllerganManagement"),
        },
        {
          key: "Recipe Management",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <AllergenIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Recipe MGMT
            </span>
          ),
          onClick: () => navigation("/AdminProductManagement/RecipeManagement"),
        },
        // {
        //   key: "Reciepe Builder",
        //   icon: (
        //     <div
        //       className="active-menu-class"
        //       style={{ padding: "10px", borderRadius: 5 }}
        //     >
        //       <ReciepeIcon width={20} height={20} />
        //     </div>
        //   ),
        //   label: (
        //     <span
        //       className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
        //     >
        //       Recipe Builder
        //     </span>
        //   ),
        //   onClick: () => navigation("/productionManagement/ReciepeBuilder"),
        // },
        {
          key: "Production Schedule",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <PS width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Production Schedule
            </span>
          ),
          onClick: () =>
            navigation("/AdminProductManagement/productionschedule"),
        },
        {
          key: "Equipment MGMT.",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <Group width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Equipment MGMT.
            </span>
          ),
          onClick: () =>
            navigation("/AdminProductManagement/EquipmentManagement"),
        },
      ],
    },
    {
      style: menuStyle,
      key: "User Management",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <USRIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">User MGMT</h4>,
      children: [
        {
          key: "Staff MGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <STFIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Staff MGMT
            </span>
          ),
          onClick: () => navigation("/AdminStaffMgmt"),
        },
        {
          key: "Training",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TRAIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Training
            </span>
          ),
          onClick: () => navigation("/userManagement/training"),
        },
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Relationship Management",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <RM width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Relationship MGMT</h4>,
      children: [
        {
          key: "Customer MGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <UM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Customer MGMT
            </span>
          ),
          onClick: () => navigation("/AdminCustomerManagement"),
        },
        {
          key: "Vendor  MGMT.",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <VN width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Vendor MGMT.
            </span>
          ),
          onClick: () => navigation("/AdminVendorManagement"),
        },
      ],
    },
    {
      style: menuStyle,
      key: "Support & Help",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HLPIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Support & Help</h4>,
      children: [
        {
          key: "Privacy & Policy",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <PRIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Privacy & Policy
            </span>
          ),
          onClick: () => navigation("/PrivacyPolicy"),
        },
        {
          key: "Terms & Condition",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TERIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Terms & Condition
            </span>
          ),
          onClick: () => navigation("/TermsConditions"),
        },
        {
          key: "Contact Us",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CONIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Contact Us
            </span>
          ),
          onClick: () => navigation("/ContactUs/"),
        },
        {
          key: "FAQ’s",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <FAQIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              FAQ’s
            </span>
          ),
          onClick: () => navigation("/Faqs"),
        },
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Settings",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SettingsIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Settings</h4>,
      onClick: () => navigation("/Settings"),
    },

    {
      style: menuStyle,
      key: "Logout",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <LogoutIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Logout</h4>,
      onClick: () => logout(),
    },
  ];
};

const supervisorMenu = ({ navigation, dispatch, t, width }) => {
  const logout = () => {
    dispatch(isLogin(false));
    localStorage.clear();
  };

  return [
    {
      style: menuStyle,
      key: "SupervisorDashboard",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HomeIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Home")}</h4>,
      onClick: () => {
        navigation("/SupervisorDashboard");
      },
    },
    {
      style: menuStyle,
      key: "supervisorCentralCommandScreen",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <CCSIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Central Command Screen </h4>,
      onClick: () => {
        navigation("/supervisorCentralCommandScreen");
      },
    },
    {
      style: menuStyle,
      key: "SupervisorProductionSchedule",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <PS width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Production Schedule</h4>,
      onClick: () => {
        navigation("/SupervisorProductionSchedule");
      },
    },
    {
      style: menuStyle,
      key: "SupervisorRecipeProduction",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <RecipeProduction width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable"> Recipe Production </h4>,
      onClick: () => {
        navigation("/SupervisorRecipeProduction");
      },
    },
    {
      style: menuStyle,
      key: "SupervisorReports",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <Reports width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable"> Reports </h4>,
      onClick: () => {
        navigation("/SupervisorReports");
      },
    },
    {
      style: menuStyle,
      key: "Warehouse ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <Warehouse width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Warehouse </h4>,
      children: [
        {
          key: "SupervisorIngredients",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <Ing width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Ingredients
            </span>
          ),
          onClick: () =>
            navigation("/SupervisorWarehouse/SupervisorIngredients"),
        },
        {
          key: "SupervisorMaterial",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <MM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Material
            </span>
          ),
          onClick: () => navigation("/SupervisorWarehouse/SupervisorMaterial"),
        },
        {
          key: "SupervisorWasteLog",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <WL width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              WasteLog
            </span>
          ),
          onClick: () => navigation("/SupervisorWarehouse/SupervisorWasteLog"),
        },
        {
          key: "SupervisorComponentMGMT",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CM width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Components
            </span>
          ),
          onClick: () => navigation("/Warehouse/SupervisorComponentMGMT"),
        },
        //
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "SupervisorEquipmentManagement",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SupEquipmentIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Equipment</h4>,
      onClick: () => navigation("/SupervisorEquipmentManagement"),
    },
    {
      style: menuStyle,
      key: "Training ",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SuptrainingIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Training</h4>,
      children: [
        {
          key: "Training Library",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TrainingLibrary width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Training Library
            </span>
          ),
          onClick: () => navigation("/Training"),
        },
        {
          key: "Reciepe",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <ReciepeIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Recipe
            </span>
          ),
          onClick: () => navigation("/Training/Reciepe"),
        },
      ],
      // onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Settings",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SettingsIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Settings</h4>,
      onClick: () => navigation("/Settings"),
    },
    {
      style: menuStyle,
      key: "Support & Help",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HLPIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Support & Help</h4>,
      children: [
        {
          key: "Privacy & Policy",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <PRIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Privacy & Policy
            </span>
          ),
          onClick: () => navigation("/PrivacyPolicy"),
        },
        {
          key: "Terms & Condition",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <TERIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Terms & Condition
            </span>
          ),
          onClick: () => navigation("/TermsConditions"),
        },
        {
          key: "Contact Us",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <CONIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Contact Us
            </span>
          ),
          onClick: () => navigation("/ContactUs/"),
        },
        {
          key: "FAQ’s",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <FAQIcon width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              FAQ’s
            </span>
          ),
          onClick: () => navigation("/Faqs"),
        },
        {
          key: "Emergency Contacts",
          icon: (
            <div
              className="active-menu-class"
              style={{ padding: "10px", borderRadius: 5 }}
            >
              <EmergencyPhone width={20} height={20} />
            </div>
          ),
          label: (
            <span
              className={width < 786 ? "collapsed-menu-lable" : "submenu-label"}
            >
              Emergency Contacts
            </span>
          ),
          onClick: () => navigation("/EmergencyContacts"),
        },
      ],
    },
    {
      style: menuStyle,
      key: "Logout",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <LogoutIcon width={20} height={20} />
        </div>
      ),
      label: <h4 className="menu-lable">Logout</h4>,
      onClick: () => logout(),
    },
  ];
};

const SideMenu = ({ collapsed, onBackClick }) => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();

  const { height, width } = useWindowDimensions();
  const role = localStorage.getItem("@role");
  const { t } = useTranslation();
  // const role = Storage.getERole("@role");

  const menus =
    role == roles.admin
      ? adminMenu({ navigation, dispatch, t, width })
      : role == roles.supervisor
        ? supervisorMenu({ navigation, dispatch, t, width })
        : StaffMemberMenu({ navigation, dispatch, t, width });

  return (
    <div className="menu-main-container">
      <div className="logo_container">
        {collapsed || width < 786 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
            }}
          >
            <img
              src={Person}
              alt="logo"
              style={{ width: "70%", height: "70%" }}
              onClick={() => navigate("/Profile")}
            />
            <TextComponent
              text={"Chris Glasser"}
              className={"NameText"}
              color="var(--white-color)"
            />
            {role == roles.admin ? (
              <div onClick={() => navigate("/EditProfile")}>
                <IoPersonCircleOutline color="var(--white-color)" />
              </div>
            ) : (
              <div onClick={() => navigate("/Profile")}>
                <IoPersonCircleOutline color="var(--white-color)" />
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
            }}
          >
            <img
              src={Person}
              alt="logo"
              style={{ width: "70%", height: "70%" }}
              onClick={() => navigate("/Profile")}
            />

            <TextComponent
              text={"Chris Glasser"}
              className={"NameText"}
              color="var(--white-color)"
            />
            <div>
              {role == roles.admin ? (
                <TextComponent
                  text={"Edit Profile"}
                  style={{
                    color: " var(--white-color)",
                    textDecoration: "underline",
                  }}
                  fontSize={"var(--smallparagraph-font-size)"}
                  fontFamily={"Poppins-regular"}
                  textDecoration={"underline"}
                  cursor={"pointer"}
                  onClick={() => navigate("/EditProfile")}
                />
              ) : (
                <TextComponent
                  text={" View Profile"}
                  style={{
                    color: " var(--white-color)",
                    textDecoration: "underline",
                  }}
                  fontSize={"var(--smallparagraph-font-size)"}
                  fontFamily={"Poppins-regular"}
                  textDecoration={"underline"}
                  cursor={"pointer"}
                  onClick={() => navigate("/Profile")}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <Menu
        _internalDisableMenuItemTitleTooltip
        className={`${collapsed ? "menu-colapsed" : "menu"}`}
        mode={"inline"}
        inlineCollapsed={width >= 786 ? collapsed : false} // 👈 never collapse on mobile
        defaultSelectedKeys={checkRouteName(location.pathname?.substring(1))}
        selectedKeys={checkRouteName(location.pathname?.substring(1))}
        defaultOpenKeys={["BusinessManagement"]} // optional: keeps submenu open by default
        items={menus}
      />
    </div>
  );
};

export default SideMenu;
